let countryData = null;

export const setCountryData = data => {
    if (!countryData) {
        countryData = data;
    }
    return countryData;
};

